var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.6,
    height: 33.3,
    viewBox: "0 0 24.6 33.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,9.5l2,1.5l-2.2,1.7L9,9.5z M7.4,5.7L7.2,7.9l-5.3-2V5.7H7.4z M9.6,27.3l2.7-1.6l2.7,1.6H9.6z M13.9,24.7 l2.8-1.7l0.3,3.6L13.9,24.7z M8.4,16.3l2.4,1.6l-2.6,1.8L8.4,16.3z M16.2,16.3l0.3,3.4l-2.7-1.8L16.2,16.3z M13.6,1.9L12.3,3 l-1.3-1.1H13.6z M9.5,2.8l1.6,1.4L9.3,5.8L9.5,2.8z M12.3,5.3l2.9,2.5L12.3,10L9.5,7.8L12.3,5.3z M15.1,2.8l0.2,2.9l-1.7-1.5 L15.1,2.8z M5.4,29.2h13.9v2.2H5.4V29.2z M7.9,23l2.8,1.7l-3.2,1.9L7.9,23z M8.5,21.4l3.8-2.5l3.8,2.6l-3.8,2.3L8.5,21.4z  M12.4,12.1l3.4,2.5l-3.4,2.3L9,14.6L12.4,12.1z M13.7,11l1.9-1.4l0.3,3.1L13.7,11z M24,7.4l0.6-0.2l0-3.5h-7.6L16.8,0H7.9L7.6,3.8 H0v3.5l0.6,0.2v1.1H0.1v1.5h0.5v0.5h1.7v-0.5h0.6V8.6H2.3V8.1L7,9.9L5.6,27.3H3.5v6h17.7v-6H19L17.6,9.9l4.8-1.8v0.5h-0.5v1.5h0.5 v0.5H24v-0.5h0.6V8.6H24L24,7.4L24,7.4z M17.4,7.9l-0.2-2.2h5.5v0.2L17.4,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterconnectIcon);
export default __webpack_public_path__ + "static/media/interconnect-icon.3ba50847752fc3e9629486716b2b110d.svg";
export { ForwardRef as ReactComponent };